import { LaunchBackgroundTaskServiceInstanceOptions } from '../../../services/webServiceRouting/types';
import { getServices as getApplicationServices } from '../../../infra/startup';
import { Task } from '../../../services/backgroundTaskService/backgroundTask/IBackgroundTaskService';
import * as T from './types';
import { OnboardingInputType } from '../../../services/userOnboardingService/types';
import { internalLogger } from '../clientOsLogger';

export default ({
  onboardingInput
}: {
  onboardingInput: OnboardingInputType;
}): T.ServiceRoutingInterfaceType => {
  const services = getApplicationServices();
  const { webServiceRouting, backgroundTaskService } = services;

  function isEnabled() {
    return onboardingInput?.enable;
  }

  async function getServiceInstanceLaunchOptions(): Promise<
    T.LaunchServiceOptions | T.ServiceRoutingError
  > {
    // const state = _getState();

    // const launchOptions = {
    //   serviceId: state?.context?.nextService?.serviceId,
    //   serviceOptions: {
    //     onboardingContext: state?.context,
    //     appSessionId: state?.appSessionId
    //   }
    // };

    const serviceInstanceLaunchOptions =
      await webServiceRouting.getServiceInstanceLaunchOptions();

    return webServiceRouting.separateErrorObject(serviceInstanceLaunchOptions)
      ?.data;
  }

  async function launchService(launchOptions: {
    /**
     * The identifier of the service that should be launched
     */
    serviceId: string;
    /**
     * Options specific to the service being launched, if any are required
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    serviceOptions?: Record<string, any>;
  }) {
    if (isEnabled()) {
      // payload.resultData.
      await webServiceRouting.launchService({
        serviceId: launchOptions?.serviceId,
        serviceOptions: launchOptions?.serviceOptions
      });
      // const state = _getState();

      // await state?.nextStage?.(payload?.resultData, {
      //   authentication: payload?.authentication
      // });
    }
  }

  async function closeServiceInstance(
    payload: T.ServiceRoutingCloseServiceInstancePropType
  ): Promise<void> {
    if (isEnabled()) {
      // payload.resultData.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      webServiceRouting.closeServiceInstance(payload as any);
      // const state = _getState();

      // await state?.nextStage?.(payload?.resultData, {
      //   authentication: payload?.authentication
      // });
    }
  }

  async function getServices(): Promise<{
    services: T.InternalServiceObjectType[];
  }> {
    const response = webServiceRouting.separateErrorObject(
      await webServiceRouting.getServices()
    )?.data;

    return response;
  }

  async function launchBackgroundTasks(
    launchOptions: LaunchBackgroundTaskServiceInstanceOptions[]
  ): Promise<void> {
    return webServiceRouting.launchBackgroundTasksService(launchOptions);
  }

  async function registerBackgroundTask(id: string, task: Task): Promise<void> {
    await backgroundTaskService.register(id, task);
  }
  return {
    launchService,
    getServiceInstanceLaunchOptions,
    closeServiceInstance,
    getServices,
    registerBackgroundTask,
    launchBackgroundTasks
  };
};

export function createNoopServiceRoutingInterface(): T.ServiceRoutingInterfaceType {
  return {
    launchService: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceRoutingInterface',
        methodName: 'launchService()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getServiceInstanceLaunchOptions: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceRoutingInterface',
        methodName: 'getServiceInstanceLaunchOptions()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    closeServiceInstance: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceRoutingInterface',
        methodName: 'closeServiceInstance()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getServices: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceRoutingInterface',
        methodName: 'getServices()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    registerBackgroundTask: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceRoutingInterface',
        methodName: 'registerBackgroundTask()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    launchBackgroundTasks: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopServiceRoutingInterface',
        methodName: 'launchBackgroundTasks()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    }
  };
}
